import { IkeAngle, IkeUnit } from '@ikegps/core-shared';
import { T } from '../../i18n';
import { NumberInputState } from './number.input.state';

export class BearingInputState extends NumberInputState {
	static DEGREE_PRECISION: number = 3;

	static override equal(value1: number, value2: number): boolean {
		const deg1 = IkeAngle.toDegrees(value1);
		const deg2 = IkeAngle.toDegrees(value2);

		return NumberInputState.equal(deg1, deg2, BearingInputState.DEGREE_PRECISION);
	}

	constructor(label: string) {
		super(label);
		this.precision = BearingInputState.DEGREE_PRECISION;
		this.isLabelShown = false;
	}

	override formatInputValue(val: number) {
		const deg = IkeAngle.toDegrees(val);
		return deg != null && !isNaN(deg) ? String(IkeUnit.round(deg, this.precision)) : null;
	}

	override parseInputValue(val: string) {
		const num = this.parseNumber(val);

		if (num == null) {
			this.setError(null);
			return null;
		}

		if (isNaN(num)) {
			this.setError(T.NUMBER_INVALID);
			return null;
		}

		this.setError(null);
		return IkeAngle.toRadians(num);
	}

	protected override parseNumber(val: string): number | null {
		const RE_NUMBER = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
		if (val.trim().length === 0) {
			return null;
		}

		const lastChar = val.slice(-1);
		if (lastChar === '.') {
			val = val.slice(0, -1);
		}

		if (val.match(RE_NUMBER) == null) {
			return NaN;
		}

		return Number(val);
	}
}
